import { Component, EventEmitter, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { mergeMap } from 'rxjs/operators';
import { IntegrationDao } from '../../../../core/services/dao/integrationDao';
import { IntegrationInvite } from '../../../../core/models/integrationInvite';
import { User } from '../../../../core/models/user';

@Component({
  selector: 'snapchat',
  templateUrl: './snapchat.component.html',
  styleUrls: ['./snapchat.component.scss']
})
export class SnapchatComponent implements OnInit, OnDestroy {
  public accounts: any[] = [];
  public adAccount: any;
  loading: boolean;
  public loginError = false;
  public accountsDisabled = false;
  disconnectOnDestroy = false;
  oauthURL = '';
  existingIntegrations = [];
  createdIntegration: any = {};
  creating = false;
  user: User;
  invites: IntegrationInvite[];
  description: string = '';
  showAccounts = false;
  integrationName;
  integrationType;
  noAccounts = false;
  isAdmin = false;
  emitter: EventEmitter<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SnapchatComponent>,
    private integrationDao: IntegrationDao
  ) {
    this.existingIntegrations = this.data.existingIntegrations;
    this.user = this.data.user;
    this.isAdmin = this.user ? this.user.isAdmin : false;
    this.invites = this.data.invites.filter(i => i.integrations.includes(this.data.type));
    this.description = this.data.description;
    this.integrationName = this.data.name;
    this.integrationType = this.data.type;
    this.emitter = this.data.emitter;
    if (this.existingIntegrations.length === 0) {
      this.creating = true;
      this.noAccounts = true;
    }
    // this.integrationDao.getSnapchatOauthUrl().subscribe(
    //   res => {
    //     this.oauthURL = res.oauthUrl;
    //   },
    //   err => console.error(err)
    // );
  }

  ngOnInit(): void {}

  toggleShowAccounts() {
    this.showAccounts = !this.showAccounts;
  }

  onViewInvitesClick() {
    this.emitter.emit(this.integrationType);
    this.dialogRef.close();
  }

  addAccount(e) {
    let account = this.accounts.find(i => i.id === this.adAccount);
    let updates = {
      accountId: this.adAccount,
      type: 'snapchat',
      enabled: true,
      timezone: account.timezone,
      friendlyName: account.name
    };
    // this.integrationDao.update(this.createdIntegration.id, updates).subscribe(res => {
    //   this.disconnectOnDestroy = false;
    //   this.dialogRef.close(res);
    // });
  }

  addAnother(e) {
    this.creating = true;
  }

  login(e) {
    if (!this.oauthURL) {
      console.error('OAuth URL not loaded');
      return false;
    }
    this.loginError = false;
    let opened = window.open(
      this.oauthURL + '&state=' + this.data.brand,
      null,
      'width=450,height=600,menubar=0,toolbar=0,location=0,personalbar=0,statusbar=0,top=100,left=100,alwaysRaised=yes'
    );

    let listener = event => {
      if (event.data) {
        if (event.data.type && event.data.type === 'snapchat' && event.data.id !== undefined) {
          this.loading = true;
          this.disconnectOnDestroy = true;
          this.integrationDao
              .loadById(event.data.id)
              .pipe(
                  // mergeMap(res => {
                  //   this.createdIntegration = res;
                  //   return this.integrationDao.getSnapchatAccounts(this.createdIntegration.id);
                  // })
              )
              .subscribe(res => {
                if (res && res.length > 0) {
                  for (let org of res) {
                    if (
                        org &&
                        org.organization &&
                        org.organization.ad_accounts &&
                        org.organization.ad_accounts.length > 0
                    ) {
                      for (let acct of org.organization.ad_accounts) {
                        this.accounts.push({
                          name: acct.name + ' - ' + org.organization.name,
                          id: acct.id,
                          timezone: acct.timezone
                        });
                      }
                    }
                  }
                }
                this.loading = false;

                // remove listener
                window.removeEventListener('message', listener);

                // close window
                opened.close();
              });
        } else {
          this.loginError = true;
        }
      }
    }

    window.addEventListener('message', listener);
  }

  ngOnDestroy() {
    if (this.disconnectOnDestroy) {
      // this.integrationDao.disconnect(this.createdIntegration.id).subscribe(() => {
      //   console.log('successfully removed integration');
      // });
    }
  }
}
